module.exports = "/fonts/iconsminds.woff2?e0f5655481a1e390664cfb2341ae9027";